module.exports = __webpack_public_path__ + "img/03.82bf8011.jpg";